import { createRouter, createWebHistory } from 'vue-router'
import NewLayout from '@/views/new/layout/NewLayout.vue'
import NewHome from '@/views/new/Home.vue'
import NewAbout from '@/views/new/About.vue'
import NewProductList from '@/views/new/ProductList.vue'
import NewProductDetail from '@/views/new/ProductDetail.vue'
import Contact from '@/views/Contact.vue'
import TechnologyCenter from '@/views/new/TechnologyCenter.vue'

// 保留原有的后台管理路由
import AdminLayout from '@/views/admin/AdminLayout.vue'
import Login from '@/views/Login.vue'
import BannerManagement from '@/views/admin/BannerManagement.vue'
import MessageManagement from '@/views/admin/MessageManagement.vue'

const routes = [
  {
    path: '/',
    component: NewLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: NewHome
      },
      {
        path: 'about',
        name: 'About',
        component: NewAbout
      },
      {
        path: 'technology',
        name: 'Technology',
        component: TechnologyCenter
      },
      {
        path: 'products',
        name: 'Products',
        component: NewProductList
      },
      {
        path: 'products/:id',
        name: 'ProductDetail',
        component: NewProductDetail
      },
      {
        path: 'contact',
        name: 'Contact',
        component: Contact
      },
      {
        path: 'news',
        name: 'News',
        component: () => import('@/views/News.vue')
      },
      {
        path: 'news/:id',
        name: 'NewsDetail',
        component: () => import('@/views/NewsDetail.vue')
      }
    ]
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/views/admin/Dashboard.vue')
      },
      {
        path: 'site',
        name: 'AdminSite',
        component: () => import('@/views/admin/SiteContentManagement.vue')
      },
      {
        path: 'products',
        name: 'AdminProducts',
        component: () => import('@/views/admin/ProductManagement.vue')
      },
      {
        path: 'categories',
        name: 'AdminCategories',
        component: () => import('@/views/admin/CategoryManagement.vue')
      },
      {
        path: 'banners',
        name: 'AdminBanners',
        component: BannerManagement
      },
      {
        path: 'contents',
        name: 'AdminContents',
        component: () => import('@/views/admin/ContentManagement.vue')
      },
      {
        path: 'messages',
        name: 'AdminMessages',
        component: MessageManagement
      },
      {
        path: 'news',
        name: 'AdminNews',
        component: () => import('@/views/admin/NewsManagement.vue')
      }
    ]
  },
  {
    path: '/admin/login',
    name: 'Login',
    component: Login
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({
        path: '/admin/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else if (to.path === '/admin/login' && token) {
    next({ path: '/admin' })
  } else {
    next()
  }
})

export default router 